import { Alert, AlertButtonProps, theme as defaultTheme } from '@dtx-company/shared-components/src'
import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { useAuthState } from '@dtx-company/inter-app/src/hooks/useAuthState'
import { usePageCanBePublished } from '../../hooks/usePageCanBePublished'
import { useRouter } from 'next/router'
import React from 'react'
import styled from 'styled-components'

const StyledAlert = styled(Alert)`
  z-index: 10;
  top: 0px;
  @media (min-width: 800px) {
    button {
      p {
        font-size: 15px;
      }
    }
  }
  p {
    font-weight: 600;
    letter-spacing: normal;
    font-family: ${defaultTheme.fontFamily};
  }

  @media (max-width: 600px) {
    border-radius: 0;
  }
`

interface PublishBannerProps {
  demo: boolean
  pageId: string
}

const PublishBanner: React.FC<PublishBannerProps> = ({ demo, pageId }) => {
  const router = useRouter()
  const { isAuthenticated } = useAuthState()
  const entity = router.query.templateId ? 'template' : 'page'
  const userHasLinkAndBio = usePageCanBePublished()
  const demoCopy = userHasLinkAndBio
    ? 'This is a preview of your Flowpage. Click Publish to save and share your page. Or click Edit to continue editing.'
    : 'This is a preview of your Flowpage. Click edit, then add a bio and a link to get started.'
  const isLoggedOutDemo = demo && !isAuthenticated
  const buttons: AlertButtonProps[] = [
    {
      label: 'Edit',
      p: ['0 10px', '0 30px'],
      width: '44px',
      height: ['30px', '35px'],
      onClick: (): void => {
        router.query.templateId
          ? router.push({
              query: { id: router.query.templateId, previewed: true },
              pathname: Routes.PAGE_TEMPLATE_EDITOR
            })
          : router.push({
              query: { demo: isLoggedOutDemo, previewed: true, id: pageId },
              pathname: Routes.PAGE_EDITOR
            })
      }
    }
  ]

  if (demo && userHasLinkAndBio) {
    buttons.push({
      label: 'Publish',
      p: ['0 32px', '0 38px'],
      width: '40px',
      height: ['30px', '35px'],
      onClick: (): void => {
        router.push(
          {
            query: { publish: true, flowpage: true },
            pathname: Routes.SIGN_UP
          },
          Routes.SIGN_UP
        )
      }
    })
  }

  return (
    <StyledAlert
      type="primary"
      positonVariant="topCenter"
      message={
        // eslint-disable-next-line no-nested-ternary
        demo ? demoCopy : `Currently viewing your live ${entity}`
      }
      buttonsPositionVariants="inline"
      buttonsProps={buttons}
      dismiss="none"
      sizeVariant={['sm', 'lg']}
      width={['100%', '600px']}
      pl={['16px', '22px']}
      mt={[null, null, '10px']}
    />
  )
}

export default PublishBanner
